module.exports = __webpack_public_path__ + "img/wheel.a8bb4d03.png";